export default __webpack_public_path__ + "img/project-estimater.b6252501.png";